<template>
  <div class="register-v2-root">
    <!--begin::Columna izquierda (66%) - fondo blanco-->
    <div class="register-v2-left">
      <!--begin::Timeline de pasos-->
      <StepTimeline :steps="steps" :current-step="currentStep" :show-logo="true"/>
      <!--end::Timeline de pasos-->

      <!--begin::Resumen del plan (solo mobile)-->
      <PlanSummaryMobile
          :current-plan="currentPlan"
          title="Tu contratación"
          empty-text="Aquí se mostrará el plan seleccionado, el coste y los beneficios."
      />
      <!--end::Resumen del plan (solo mobile)-->

      <!--begin::Contenido del paso actual-->
      <main class="register-v2-content">
        <slot/>
      </main>
      <!--end::Contenido del paso actual-->
    </div>
    <!--end::Columna izquierda-->

    <!--begin::Columna derecha (33%) - resumen fijo (solo desktop)-->
    <aside class="register-v2-summary d-none d-lg-block">
      <a href="#" class="register-v2-close" @click.prevent="onClose">
        <span>Cerrar</span>
        <i class="bi bi-x-lg"></i>
      </a>
      <div class="register-v2-summary-inner">
        <h3 class="register-v2-summary-title">Tu contratación</h3>

        <p v-if="!currentPlan.hash" class="text-muted">
          Aquí se mostrará el plan seleccionado, el coste y los beneficios.
        </p>

        <PlanSummaryDetails v-else :current-plan="currentPlan"/>
      </div>
    </aside>
    <!--end::Columna derecha-->
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {storeToRefs} from 'pinia';
import {useRegisterV2Step} from '~/composables/useRegisterV2Step';
import {usePlansClientStore} from '~/stores/entities/client/plansClient';
import {useAuthStore} from '~/stores/auth';
import {useUtil} from '~/composables/useUtil';
import StepTimeline from '~/components/plan-layout/StepTimeline.vue';
import PlanSummaryDetails from '~/components/plan-layout/PlanSummaryDetails.vue';
import PlanSummaryMobile from '~/components/plan-layout/PlanSummaryMobile.vue';
import LayoutService from '@/theme/metronic/services/LayoutService';

export default defineComponent({
  name: 'register-v2',
  components: {StepTimeline, PlanSummaryDetails, PlanSummaryMobile},
  setup() {
    const {currentStep} = useRegisterV2Step();
    const plansClientStore = usePlansClientStore();
    const {currentPlan} = storeToRefs(plansClientStore);
    const authStore = useAuthStore();
    const router = useRouter();

    onMounted(() => {
      // Limpia clases de "body" que pudiera haber dejado otro layout (p.ej. la imagen de
      // fondo del login), igual que hacen los layouts "reales" (default.vue, etc). Este
      // layout no necesita ninguna clase propia en "body".
      LayoutService.emptyElementClassesAndAttributes(document.body);
    });

    const steps = [
      {number: 1, label: 'Datos de usuario'},
      {number: 2, label: 'Verificar correo'},
      {number: 3, label: 'Seleccionar plan'},
      {number: 4, label: 'Datos adicionales'},
      {number: 5, label: 'Método de pago'},
      {number: 6, label: 'Finalizar'},
    ];

    const onClose = async () => {
      await authStore.logout();
      router.push(useUtil().generateLink('/iniciar-sesion'));
    };

    return {
      steps,
      currentStep,
      currentPlan,
      onClose,
    };
  },
});
</script>

<style scoped>
.register-v2-root {
  display: flex;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}

/* Columna izquierda: 66% */
.register-v2-left {
  width: 66%;
  height: 100%;
  display: flex;
  background-color: #ffffff;
  overflow-y: auto;
}

.register-v2-content {
  flex: 1 1 auto;
  padding: 40px;
}

/* Columna derecha: 33%, estática/fija */
.register-v2-summary {
  width: 34%;
  height: 100%;
  background-color: #f5f6fa;
  overflow-y: auto;
  flex-shrink: 0;
  position: relative;
}

.register-v2-close {
  position: absolute;
  top: 24px;
  right: 32px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #000000;
  font-weight: 600;
  text-decoration: none;
}

.register-v2-close:hover {
  color: #000000;
  opacity: 0.7;
}

.register-v2-summary-inner {
  padding: 40px;
}

.register-v2-summary-title {
  font-weight: 700;
  margin-bottom: 16px;
}

@media (max-width: 991.98px) {
  .register-v2-root {
    flex-direction: column;
    height: auto;
    overflow: visible;
  }

  .register-v2-left {
    width: 100%;
    height: auto;
    flex-direction: column;
  }
}
</style>
